import React from "react";
import { TimesheetTasksTabSkeleton } from "./TimesheetDetailTabSkeletons";

const TimesheetTabContentShell = ({
  loading,
  loadingSkeleton,
  empty,
  emptyMessage = "No data available.",
  children,
  minHeight = "py-12",
}) => {
  if (loading) {
    const Skeleton = loadingSkeleton || TimesheetTasksTabSkeleton;
    return (
      <div className="timesheet-tab-content min-h-0">
        <Skeleton />
      </div>
    );
  }

  if (empty) {
    return (
      <div
        className={`flex items-center justify-center ${minHeight} rounded-xl border border-dashed border-[#E5E7EB] bg-[#F8FAFC] px-6 text-sm text-[#94A3B8]`}
      >
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className="timesheet-tab-content">{children}</div>
  );
};

export default TimesheetTabContentShell;
